// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"379":"e6e82f0e","703":"1a8dd974"}[chunkId] + ".chunk.js";
};